import { render } from "./DashboardMostViewedProducts.vue?vue&type=template&id=84c3cbc8&ts=true"
import script from "./DashboardMostViewedProducts.vue?vue&type=script&lang=ts"
export * from "./DashboardMostViewedProducts.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__